
import React from 'react';
import { Outlet } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import {Container, Row, Col} from 'react-bootstrap';

const Layout = ({ children }) => {
  return (
    // <div className="layout">
    <Container fluid className="layout">
      <Row>
        <Col lg={12}>
          <Header />
        </Col>
        <Col lg={12}>
          <Outlet />
        </Col>
        <Col lg={12}>
          <Footer />
        </Col>
      </Row>
      </Container>

    // </div>
  );
};

export default Layout;